/* eslint-disable no-shadow */
import { ComponentType } from 'react';

import { SortCamposProps } from '../Search/types';

export enum AgregadorTipo {
  COUNT = 0,
  COUNT_DISTINCT = 1,
  SUM = 2,
  MAX = 3,
  MIN = 4,
  AVG = 5,
  NENHUM = -1,
}

export type HeadersProps = {
  codCampo: number;
  disableReorder: boolean;
  field: string;
  headerName: string;
  nome_bd: string;
  order: number;
  sortingOrder: string[];
  visibility: boolean;
  width: number;
  tipo_agregador_tot: number;
  cod_tipo_dados: number;
  tipo_expressao: number | null;
  listagem_info: string | null;
};

type DataTableComponents = {
  LoadingOverlay?: ComponentType<any>;
  Pagination?: ComponentType<any>;
};

/**
 * Configuração para injetar uma coluna dinâmica na tabela.
 * Todas as chaves são **opcionais** para facilitar o uso incremental.
 */
export type ExtraColumnConfig<RowT = any> = {
  /** Componente React que será renderizado na célula da coluna extra. Recebe { row, rowIndex, columns, onRowClick }. */
  component?: ComponentType<{
    row: RowT;
    rowIndex: number;
    columns: HeadersProps[];
    onRowClick?: (param: { row: RowT }) => void;
  }>;
  /** Posição da coluna na tabela. 'left' | 'right'. Default: 'right'. */
  position?: 'left' | 'right';
  /** Se a coluna deve ficar fixa (sticky) enquanto as demais rolam. Default: false. */
  sticky?: boolean;
  /** Título exibido no cabeçalho da nova coluna. Default: 'Ações'. */
  headerName?: string;
  /** Largura da coluna em pixels. Default: 120. */
  width?: number;
};

export type DataTableProps = {
  columns: HeadersProps[];
  rows: readonly any[];
  loading: boolean;
  components?: DataTableComponents;
  totals: any;
  onRowClick: (param: any) => void;
  handleSort: (field: string) => void;
  sortCampos: SortCamposProps[];
  /** Coluna extra opcional (dinâmica) a ser adicionada sem alterar as colunas originais. */
  extraColumn?: ExtraColumnConfig;
};
